<template>
  <div style="color: #ff000">
    {{ $t('client.no_license.text') }}
  </div>
</template>
